import * as DialogPrimitive from "@radix-ui/react-dialog";
import type { ComponentProps } from "react";

export const DialogClose = ({ ...props }: ComponentProps<typeof DialogPrimitive.Close>) => {
  return <DialogPrimitive.Close data-slot="dialog-close" {...props} />;
};
